export const ORDER_TYPE = {
  DELIVERY: "D",
  TAKEAWAY: "T",
  PICKUP: "P",
  DINEIN: "DINEIN",
  CURB: "CURB",
};

export const ORDER_STATUS_LONG_HISTORY = {
  [ORDER_TYPE.DELIVERY]: "Delivered",
  [ORDER_TYPE.TAKEAWAY]: "Picked up",
  [ORDER_TYPE.PICKUP]: "Picked up",
  [ORDER_TYPE.IRCTC]: "Delivered",
  [ORDER_TYPE.DINEIN]: "Picked up",
  [ORDER_TYPE.CURB]: "Picked up",
};

export const OrderHistoryRatingLabels = {
  ORDER_RATING_LABEL: "Rate your order",
  ORDER_RATED_LABEL: "Overall order rating",
  ORDER_DELIVERY_RATING_LABEL: "How was your delivery?",
  ORDER_TAKEAWAY_RATING_LABEL: "How was your service?",
  ORDER_FOOD_RATING_LABEL: "How was your food?",
};

export const OrderStatusCode = {
  [ORDER_TYPE.DELIVERY]: {
    1: "Order Confirmed",
    2: "Being Prepared",
    4: "Dispatched",
    5: "Cancelled",
    9: "Delivered",
    10: "Advance Order",
  },
  [ORDER_TYPE.TAKEAWAY]: {
    1: "Order Confirmed",
    2: "Being Prepared",
    4: "Order is ready",
    5: "Cancelled",
    9: "Picked Up",
    10: "Advance Order",
  },
  [ORDER_TYPE.PICKUP]: {
    1: "Order Confirmed",
    2: "Being Prepared",
    4: "Order is ready",
    5: "Cancelled",
    9: "Picked Up",
    10: "Advance Order",
  },
  [ORDER_TYPE.CURB]: {
    1: "Order Confirmed",
    2: "Being Prepared",
    4: "Order is ready",
    5: "Cancelled",
    9: "Picked Up",
    10: "Advance Order",
  },
  [ORDER_TYPE.DINEIN]: {
    1: "Order Confirmed",
    2: "Being Prepared",
    4: "Order is ready",
    5: "Cancelled",
    9: "Picked up",
    10: "Advance Order",
  },
};

export const OrderStatusBgColor = {
  [ORDER_TYPE.DELIVERY]: {
    1: "bg-grey",
    2: "bg-grey",
    4: "bg-grey",
    5: "bg-red",
    9: "bg-grey",
    10: "bg-blue",
  },
  [ORDER_TYPE.TAKEAWAY]: {
    1: "bg-grey",
    2: "bg-grey",
    4: "bg-grey",
    5: "bg-red",
    9: "bg-grey",
    10: "bg-blue",
  },
  [ORDER_TYPE.PICKUP]: {
    1: "bg-grey",
    2: "bg-grey",
    4: "bg-grey",
    5: "bg-red",
    9: "bg-grey",
    10: "bg-blue",
  },
  [ORDER_TYPE.CURB]: {
    1: "bg-grey",
    2: "bg-grey",
    4: "bg-grey",
    5: "bg-red",
    9: "bg-grey",
    10: "bg-blue",
  },
  [ORDER_TYPE.DINEIN]: {
    1: "bg-grey",
    2: "bg-grey",
    4: "bg-grey",
    5: "bg-red",
    9: "bg-grey",
    10: "bg-blue",
  },
};

export const OrderStatusTimelineConstantsForDelivery = [
  {
    id: 1,
    text: "Confirmed",
  },
  {
    id: 2,
    text: "Being Prepared",
  },
  {
    id: 4,
    text: "Out for Delivery",
  },
  {
    id: 9,
    text: "Delivered",
  },
];

export const OrderStatusTimelineConstantsForTakeAway = [
  {
    id: 1,
    text: "Confirmed",
  },
  {
    id: 2,
    text: "Being Prepared",
  },
  {
    id: 4,
    text: "Ready",
  },
  {
    id: 9,
    text: "Picked Up",
  },
];

export const OrderStatusTimelineConstantsForDinein = [
  {
    id: 1,
    text: "Confirmed",
  },
  {
    id: 2,
    text: "Being Prepared",
  },
  {
    id: 4,
    text: "Ready",
  },
  {
    id: 9,
    text: "Picked Up",
  },
];

export const DISABLED_ORDER_TYPE = {
  DINE_IN: "DINEIN",
  DELIVERY: "D",
  PICKUP: "P",
};

export const OrderStatusTimelineTextForDelivery = {
  1: "Your order is confirmed 🎉",
  2: "Preparing your food!",
  4: "Rider is on the way!",
  5: "Cancelled",
  9: "Arrived at your location in",
  10: "Advance Order",
};

export const OrderStatusHelpBottomTextForDeliveryKey = {
  1: "confirmedBottomTxt",
  2: "preparingBottomTxt",
  4: "dispatchBottomTxt",
  10: "arrivedBeforeBottomTxt",
  9: "deliveredMsg",
};

export const OrderStatusImgIconKey = {
  1: "confirmedIcon",
  2: "bakingIcon",
  4: "dispatchIcon",
  9: "deliveredIcon",
  10: "reachedGateIcon",
};

export const BottomWidgetOrderStatusImgIconKey = {
  4: "dispatchIcon",
};

export const TimeStatusTagBgColorClass = {
  DELAYED: "",
  ON_TIME: "bg-color-success-light",
  SLIGHT_DELAY: "",
};

export const TimeStatusTagFontColorClass = {
  DELAYED: "color-error-hongs",
  ON_TIME: "color-green-active",
  SLIGHT_DELAY: "color-alert",
};

export const ShowBoltIcon = {
  DELAYED: false,
  ON_TIME: true,
  SLIGHT_DELAY: false,
};

export const PostDeliveryBgColorClass = {
  DELAYED: "delayed-delivery",
  ON_TIME: "on-time-delivery",
  SLIGHT_DELAY: "delayed-delivery",
};

export const DigInText = "Dig in! Your piping hot meal awaits";
export const onTimeText = "ON-TIME";
export const slightDelayText = "SLIGHT DELAY";
export const delayText = "DELAY";
export const ValidActiveOrderStatus = [1, 2, 4, 9, 11];

export const OrderStatusAwaitedText = "Order Status Awaited";
